export function createThemeOrderSessionSnapshot({
  themeId,
  sessionStartTime,
  sessionEndTime,
} = {}) {
  if (themeId === undefined || themeId === null || !sessionStartTime || !sessionEndTime) return null
  return {themeId, sessionStartTime, sessionEndTime}
}

export function isThemeOrderSessionOccupied({
  order,
  session,
  currentOrderId,
} = {}) {
  if (!order || !session) return false

  const isSameSlot = String(order.goodsId) === String(session.themeId)
    && order.orderCreateTime === session.date
    && order.sessionStartTime === session.startTime
    && order.sessionEndTime === session.endTime
  if (!isSameSlot) return false

  const hasCurrentOrderId = currentOrderId !== undefined
    && currentOrderId !== null
    && currentOrderId !== ''
  return !hasCurrentOrderId || String(order.id) !== String(currentOrderId)
}

export function resolveThemeOrderOriginalSession({
  currentThemeId,
  originalSession,
  sessions = [],
} = {}) {
  if (!originalSession || String(currentThemeId) !== String(originalSession.themeId)) return null
  if (!Array.isArray(sessions)) return null

  return sessions.find(item => item
    && !item.disabled
    && item.startTime === originalSession.sessionStartTime
    && item.endTime === originalSession.sessionEndTime
  ) || null
}
